import React, { Component } from "react";
import { setShowDoorKeyPopup } from '../../layout2.0/action/action';
import { connect } from 'react-redux'
import {withTranslation} from 'react-i18next'

class DoorKeyPopup extends Component{

    constructor(props){
        super(props);
    }

    render(){
        const {t} = this.props
        return(
            <section className="overlay">
                <div className="overlay-window-container">
                    <div className="overlay-window">
                        <div className="overlay-content padding-0">
                            <div className="overlay-header">
                                <div className="overlay-header-title">
                                    <h2 style={{color: "#000 !important"}}>{t('door_key.for_activation_key')}</h2>
                                </div>
                                <div className="overlay-header-icon">
                                    <i className="fas fa-key"></i>
                                </div>
                            </div>
                            <div className="overlay-header-body">
                                <p>{t('door_key.proceed_to_front_desk')}</p>
                            </div>
                        </div>
                        <div className="overlay-controls">
                            <button onClick = {() => this.props.setShowDoorKeyPopup(false)} className="button secondary w-100">{t('door_key.close')}</button>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default connect(null,{
    setShowDoorKeyPopup
})(withTranslation('translations')(DoorKeyPopup));